const taxBrackets = [
    {
        values: [0, 18200],
        base: 0,
        rate: 0,
    },
    {
        values: [18200, 45000],
        base: 0,
        rate: 0.19,
    },
    {
        values: [45000, 120000],
        base: 5092,
        rate: 0.325,
    },
    {
        values: [120000, 180000],
        base: 29467,
        rate: 0.37,
    },
    {
        values: [180000, 9999999],
        base: 51667,
        rate: 0.45,
    }
];

export const calculateCoverPreTax = (coverAfterTax) => {
    const equivalentAnnualAfterTaxIncome = coverAfterTax * 12;

    const {
        rate: applicableTaxRate,
        base: appplicableBaseTaxPayable,
        values: bracketValues
    } = taxBrackets.find(bracket => {
        return equivalentAnnualAfterTaxIncome >= bracket.values[0] &&
            equivalentAnnualAfterTaxIncome < bracket.values[1]
    });

    const equivalentAnnualGrossIncome =
        (equivalentAnnualAfterTaxIncome + appplicableBaseTaxPayable - bracketValues[0] * applicableTaxRate) /
        (1 - applicableTaxRate);
    return equivalentAnnualGrossIncome / 12;
}

export const calculateCover = (grossIncomeAnnual, grossIncomeOtherAnnual, debtRepaymentMonthly, householdExpenseWeekly) => {
    const maxCover = (grossIncomeAnnual * 0.70) / 12;
    const householdExpenseMonthly = householdExpenseWeekly * 52 / 12;
    const otherIncomeMonthly = grossIncomeOtherAnnual / 12;

    let coverAfterTax = debtRepaymentMonthly + householdExpenseMonthly - otherIncomeMonthly;
    coverAfterTax = coverAfterTax < 0 ? 0 : coverAfterTax;

    const coverPreTax = calculateCoverPreTax(coverAfterTax);

    // console.log('______')
    // console.log(netIncome)
    // console.log(netIncomeMonthly)
    // console.log(maxCover)
    // console.log(householdExpenseMonthly)
    // console.log('....')
    // console.log(debtRepaymentMonthly)
    // console.log(householdExpenseMonthly)
    // console.log(otherIncomeMonthly)
    // console.log(coverAfterTax)
    // console.log(coverPreTax)
    // console.log('...')
    // console.log(Math.min(maxCover, (Math.max(coverPreTax, 0))))
    // console.log('______')

    // const maxCoverRequired = coverPreTax < maxCover;
    return Math.min(maxCover, (Math.max(coverPreTax, 0)))
}

